var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticStyle:{"margin-top":"100px"}},[_vm._v("counter: "+_vm._s(_vm.getCounter))])])
}
var staticRenderFns = []

export { render, staticRenderFns }